import React from 'react';

// Styles & Assets
import styles from './CalendarViewOption.module.css';

// Interfaces
interface Props {
    label: string
    icon: React.ReactNode
}

const CalendarViewOption: React.FC<Props> = ({ label, icon }) => {
    return (
        <div className={styles.calendarOption}>
            {icon}
            <p>{label}</p>
        </div>
    );
};
export default CalendarViewOption;